import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Dropdown, Popup } from 'semantic-ui-react'

import { ACCESS_LEVELS } from 'app'
import { Avatar, ImageSchema } from 'images'
import { SimpleButton } from 'ui'

import styles from './index.css'

const isEmail = (val) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    String(val).toLowerCase(),
  )

const isNIN = (val) => `${val}`.replaceAll(/([^0-9])/gi, '').length === `${val}`.length

class PermissionsList extends PureComponent {
  state = {
    accessLevel: ACCESS_LEVELS.ADMIN,
    isAddingPermission: false,
    searchMessage: 'Busca por email o identificación completos',
    userId: '',
  }

  getAccessText = (level) => this.props.accessOptions.find((a) => a.value === level)?.text

  onAdd = () => {
    this.props.onChange(this.state.userId, this.state.accessLevel)
    this.setState({ isAddingPermission: false, userId: '' })
  }

  onChange = (_, { id, value }) => this.props.onChange(id, value)

  onChangeField = (_, { name, value }) => this.setState({ [name]: value })

  onRemove = ({
    currentTarget: {
      dataset: { id },
    },
  }) => this.props.onRemove(id)

  onRestore = ({
    currentTarget: {
      dataset: { id },
    },
  }) => this.props.onRestore(id)

  onSearchChange = (_, { searchQuery }) => {
    let searchMessage = ''
    if (searchQuery.length >= 5) {
      if (isNIN(searchQuery) || isEmail(searchQuery)) {
        this.props.onSearchChange(searchQuery)
      } else {
        searchMessage = 'No es email o identificación válido'
      }
    } else {
      searchMessage = 'Busca por email o identificación completos'
    }
    this.setState({ searchMessage, userId: '' })
  }

  onToggleAddingPermission = () =>
    this.setState((prevState) => ({
      isAddingPermission: !prevState.isAddingPermission,
    }))

  renderAddingPermissionRow() {
    const { accessOptions, isSearching, searchResults } = this.props
    const options = searchResults.map((r) => ({
      text: `${r.name} <${r.email}>${!!r.nin && ` #${r.nin}`}`,
      value: r.id,
    }))
    return (
      <tr>
        <td>
          <Dropdown
            clearable
            fluid
            loading={isSearching}
            name="userId"
            noResultsMessage={
              isSearching
                ? 'Buscando...'
                : this.state.searchMessage || (!!options.length && '') || 'No se encontraron resultados'
            }
            onChange={this.onChangeField}
            onSearchChange={this.onSearchChange}
            options={options}
            placeholder={this.state.searchMessage}
            search
            selection
            value={this.state.userId}
          />
        </td>
        <td>
          <Popup
            content="Seleccionar nivel de acceso"
            size="mini"
            trigger={
              <Dropdown
                className={styles.options}
                defaultValue={accessOptions[0].value}
                inline
                name="accessLevel"
                onChange={this.onChangeField}
                options={accessOptions}
              />
            }
            value={this.state.accessLevel}
          />
        </td>
        <td>
          {!!this.state.userId && (
            <Popup
              content="Agregar permiso"
              size="mini"
              trigger={
                <SimpleButton
                  className={styles.icon}
                  disabled={!this.state.accessLevel || !this.state.userId}
                  icon="add"
                  onClick={this.onAdd}
                  primary
                />
              }
            />
          )}
        </td>
      </tr>
    )
  }

  render() {
    const { accessOptions, className, permissions } = this.props
    const { isAddingPermission } = this.state

    return (
      <div className={classnames('pb-20', className)}>
        <div className={styles.header}>
          <div>
            <h2>Personas con acceso</h2>
            <div>Permisos asignados</div>
          </div>
          <div>
            <SimpleButton
              icon={isAddingPermission ? 'undo' : 'plus'}
              onClick={this.onToggleAddingPermission}
              primary={!isAddingPermission}
              value={isAddingPermission ? 'Cancelar' : 'Agregar'}
            />
          </div>
        </div>
        <table className={styles.list}>
          <thead>
            <tr>
              <th width="60%">Nombre</th>
              <th width="20%">Acceso</th>
              <th aria-label="Acciones" width="20%" />
            </tr>
          </thead>
          <tbody>
            {isAddingPermission && this.renderAddingPermissionRow()}
            {permissions.map((perm) => (
              <tr key={perm.id} className={classnames(!!perm.deletedAt && styles.deleted)}>
                <td>
                  <div className={styles.userInfo}>
                    <Avatar size="2em" src={perm.user.avatar} />
                    <div>
                      <div>{perm.user.name}</div>
                      <span>{perm.user.email}</span>
                    </div>
                  </div>
                </td>
                <td>
                  {perm.readOnly || perm.deletedAt ? (
                    <span className={styles.options}>{this.getAccessText(perm.accessLevel)}</span>
                  ) : (
                    <Popup
                      content="Cambiar nivel de acceso"
                      size="mini"
                      trigger={
                        <Dropdown
                          id={perm.user.id}
                          className={styles.options}
                          defaultValue={perm.accessLevel}
                          inline
                          onChange={this.onChange}
                          options={accessOptions}
                        />
                      }
                    />
                  )}
                </td>
                <td>
                  {!perm.readOnly && !!perm.deletedAt && (
                    <Popup
                      content="Deshacer eliminar"
                      size="mini"
                      trigger={<SimpleButton data-id={perm.id} onClick={this.onRestore} secondary value="Restaurar" />}
                    />
                  )}
                  {!perm.readOnly && !perm.deletedAt && (
                    <Popup
                      content="Eliminar permisos"
                      size="mini"
                      trigger={
                        <SimpleButton
                          className={styles.icon}
                          data-id={perm.id}
                          icon="remove"
                          onClick={this.onRemove}
                          secondary
                        />
                      }
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

PermissionsList.propTypes = {
  accessOptions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,

      disabled: PropTypes.bool,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  permissions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      accessLevel: PropTypes.number.isRequired,
      deletedAt: PropTypes.number,
      user: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,

        avatar: ImageSchema,
        email: PropTypes.string,
      }).isRequired,

      readOnly: PropTypes.bool,
    }),
  ).isRequired,
  searchResults: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      avatar: ImageSchema,
      email: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      nin: PropTypes.string,
    }),
  ).isRequired,

  className: PropTypes.string,
  isSearching: PropTypes.bool,
}

PermissionsList.defaultProps = {
  className: '',
  isSearching: false,
}

export default PermissionsList
